import FullPageMessage from "@/components/FullPageMessage";
import GoToSelectedOrgButton from "@/components/GoToSelectedOrgButton";
import { Button } from "@/components/ui/button";
import { signOutUser } from "@/lib/auth";

/**
 * Shown for an `/orgs/{id}` URL the signed-in user cannot reach, instead of a
 * silent bounce into another org. Signing out keeps the URL, so the account
 * that was invited opens the link straight away.
 */
export default function OrganizationAccessDenied() {
  return (
    <FullPageMessage title="You don't have access to this organization">
      <p className="text-muted-foreground">
        This organization doesn't exist or you don't have access to it. Ask an admin of that organization to invite
        you, or sign in with the account they invited.
      </p>
      <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
        <GoToSelectedOrgButton />
        <Button
          variant="outline"
          onClick={() => void signOutUser()}>
          Use another account
        </Button>
      </div>
    </FullPageMessage>
  );
}
